import PromptInput from "common/widgets/PromptList/PromptInput";
import TextArea from "common/widgets/TextArea/TextArea";
import DFAutoresizeTextArea from "app/widgets/TextArea/DFAutoresizeTextArea";
import ManyInput from "app/widgets/ManyInput/ManyInput";
const TextAreaPromptInput = PromptInput.extend({
    options: {
        name: "TextAreaPromptInput",
        template: "<textarea>"
    },
    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);

        if (!this.options.model.width && !this.options.model.height) {
            // non-forms cases.
            var passOptions = {
                characterCase: this.options.model.characterCase,
                preventEnter: this.options.model.preventEnterKey === true
            };

            if (this.options.model.maxLength) {
                passOptions.maxlength = this.options.model.maxLength;
            }
            if (this.options.model.allowMultipleValues) {
                var me = this;
                this.widget = new ManyInput(this.input, {
                    widget: DFAutoresizeTextArea,
                    template: "<textarea>",
                    widgetOptions: passOptions,
                    addOnEnter: false,
                    inputCreated: function(e) {
                        me.addFocusables([e.widget, e.add, e.remove]);
                    }
                });
            } else {
                this.widget = new DFAutoresizeTextArea(this.input, passOptions);
            }
            this.widget.bind("change", this.handleChange);
        } else {
            // forms cases.
            // else use standard textarea element, in order to respect the set width and height,
            // and keep control from expanding over other controls in the prompt list.
            this.handleTextChange = $.proxy(this.handleTextChange, this);
            this.widget = new TextArea(this.input, {
                maxlength: this.options.model.maxLength,
                change: this.handleTextChange
            });

            // width is set on the parent in PromptList; make sure height fills parent space here, since
            // height is not set generically for all form control types
            if (this.options.model.width && this.options.model.height) {
                this.element.parent().addClass("textareaControl flexLayout");
            }

            this._updateSize();
        }
        this.refresh();
    },

    destroy: function() {
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
        }
        if (this.input) {
            this.input.unbind("change", this.handleTextChange);
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    /**
     * Override
     */
    _getFocusWidgets: function(showAll) {
        if (this.options.model.allowMultipleValues && this.widget) {
            return this.widget.getFocusWidgets(showAll);
        }
        return PromptInput.fn._getFocusWidgets.apply(this, arguments);
    },

    // Only call readOnly when not absolutely positioned. Otherwise, enabled handling displays the readonly (disabled)
    // mode of the control. When absolutely positioned, we need to use scrolling to access the full text, rather than wrapping
    // on our own with our special readonly mode.
    readonly: function(val) {
        if (!this.options.disabledWhenReadonly) {
            PromptInput.fn.readonly.call(this, val);
        } else {
            this._readonlyEnable(val);
        }
    },

    handleTextChange: function() {
        this.options.model.set("value", this.parseValue($(this.input).val()));
    },

    /**
     * Override
     * Ensure default value of null (DefaultValueApply) is maintained when there is no value
     * @param x
     * @returns {*}
     */
    parseValue(x) {
        if(this.options.model.allowMultipleValues && (!x || !x.length)) {
            return null;
        }
        return PromptInput.fn.parseValue.apply(this, arguments);
    },

    getMinSize: function() {
        var minSize = PromptInput.fn.getMinSize.apply(this, arguments);
        minSize.width = 30;
        minSize.height = 30;
        return minSize;
    },

    updateSize: function() {
        PromptInput.fn.updateSize.apply(this, arguments);
        this._updateSize();
    },

    _updateSize: function() {
        if (this.options.width && this.options.height) {
            this.element.parent().css("height", this.options.height + "px");
        }
    },

    /**
     * Override
     */
    commitValue() {
        const focusedWidget = this._getFocused();
        if(focusedWidget instanceof TextArea) {
            focusedWidget._valueChange();
        } else {
            PromptInput.fn.commitValue.apply(this, arguments);
        }
    }
});
kendo.ui.plugin(TextAreaPromptInput);
export default TextAreaPromptInput;
